module.exports = {
  siteTitle: 'Afloat Inc.', // Site title.
  siteTitleAlt: 'AI for streaming Business', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://www.afloatinc.com', // Domain of your website without pathPrefix.
  pathPrefix: '', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'A technology startup for intelligent media streaming and AI for human sentiment analysis.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: 'www-afloatinc-com', // Disqus shortname.
  userName: 'Nirmit Dinesh',
  userTwitter: '@IncAfloat',
  userLocation: 'Lexington, MA, USA',
  userDescription: '',
  copyright: 'Copyright © Afloat Inc 2019-2020. All Rights Reserved.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}
